import * as React from 'react'

import { GridBlock } from './blocks/GridBlock'
import { SCENE_HEIGHT, BOTTOM_PADDING, REST_BLOCK_HEIGHT } from './utils/layout'

export type TimelineSkeletonProps = {
  width?: number
  height?: number
  startTime?: any
  isMonth?: boolean
}

const GRID_HEIGHT = 50

const BARS: ReadonlyArray<{ h: number; grow: number }> = [
  { h: 0.6, grow: 3 },
  { h: 1, grow: 1 },
  { h: 0.8, grow: 2 },
  { h: 0.6, grow: 4 },
  { h: 1, grow: 1 },
  { h: 0.7, grow: 2 },
  { h: 0.8, grow: 3 },
  { h: 0.6, grow: 1 },
  { h: 1, grow: 2 },
  { h: 0.7, grow: 4 },
  { h: 0.8, grow: 1 },
  { h: 0.6, grow: 2 },
]

export const TimelineSkeleton: React.FC<TimelineSkeletonProps> = ({
  width,
  height = SCENE_HEIGHT,
  startTime,
  isMonth = false,
}) => {
  const showGrid = !!width && width > 0 && startTime != null

  return (
    <div
    className="tw-bg-white"
      style={{
        position: 'relative',
        width: width && width > 0 ? width : '100%',
        height,
        overflow: 'hidden',
      }}
      aria-hidden="true"
    >
      <div
        className="tw-flex tw-items-end"
        style={{
          position: 'absolute',
          inset: 0,
          paddingBottom: BOTTOM_PADDING,
          gap: 2,
        }}
      >
        {BARS.map((bar, index) => (
          <div
            key={index}
            className="tw-animate-pulse tw-rounded-t-[3px] tw-bg-gray-200"
            style={{
              flexGrow: bar.grow,
              flexBasis: 0,
              height: Math.round(REST_BLOCK_HEIGHT * bar.h),
            }}
          />
        ))}
      </div>

      {showGrid && (
        <GridBlock
          startTime={startTime}
          width={width as number}
          height={GRID_HEIGHT}
          isMonth={isMonth}
        />
      )}
    </div>
  )
}

TimelineSkeleton.displayName = 'TimelineSkeleton'
